var ___EXPOSE_LOADER_IMPORT___ = require("-!./awesomplete.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../expose-loader@3.0.0_webpack@5.75.0_webpack-cli@5.1.4_/node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
var ___EXPOSE_LOADER_IMPORT_MODULE_LOCAL_NAME___ = ___EXPOSE_LOADER_IMPORT___.Awesomplete
___EXPOSE_LOADER_GLOBAL_THIS___["Awesomplete"] = ___EXPOSE_LOADER_IMPORT_MODULE_LOCAL_NAME___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
